import type { SkeletonContainerElement } from "shared/atoms/SkeletonLayout";
import { SkeletonLayout } from "shared/atoms/SkeletonLayout";

export const SettingsTemplateSkeleton: React.FC = () => {
  return (
    <SkeletonLayout
      layout={{
        type: "column",
        spacing: 1,
        children: [...Array(6)].map(
          (): SkeletonContainerElement => ({
            type: "row",
            spacing: 1,
            padding: 1.5,
            alignItems: "center",
            children: [
              { type: "skeleton", variant: "rounded", width: 36, height: 36 },
              {
                type: "column",
                spacing: 0.5,
                children: [
                  { type: "skeleton", variant: "text", typographyVariant: "body_bold", width: 120 },
                  { type: "skeleton", variant: "text", typographyVariant: "label", width: 80 },
                ],
              },
            ],
          })
        ),
      }}
    />
  );
};
